export enum inputLoginId{
    INPUT_USER_LOGIN='input-user-login',
    INPUT_PASSWORD_LOGIN='input-password-login',
    INPUT_SUBMIT_LOGIN='input-submit-login'
}
